import { Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import { switchMap } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';
import { CmsDestination } from '@fcom/core-api';
import { OndPageType } from '@fcom/ond-marketing-landing-core/interfaces/ond-marketing-offers.interface';
import { OndMarketingOffersService } from '@fcom/ond-marketing-landing-core/services/ond-marketing-offers.service';
import { getCurrentCountry } from '@fcom/ond-marketing-landing-core/services/utils';

@Component({
  selector: 'cms-ond-marketing-cross-linking',
  template: `
    @if (route.url | async; as routeSegments) {
      <fin-ond-marketing-cross-linking
        class="section-two-thirds-right col-1-12 md-col-1-9 ms-large-b"
        [route]="routeSegments"
        [links]="links()"
        [ondPageType]="ondPageType"
      />
    }
  `,
  standalone: false,
})
export class CmsOndMarketingCrossLinkingComponent {
  readonly route = inject(ActivatedRoute);
  private ondMarketingOffersService = inject(OndMarketingOffersService);
  private languageService = inject(LanguageService);

  readonly content = input.required<CmsDestination>();
  readonly ondPageType: OndPageType = OndPageType.LANDING;

  readonly links = toSignal(
    this.ondMarketingOffersService.getDestinationLocationCode(toObservable(this.content)).pipe(
      switchMap((destinationLocationCode) => {
        return this.ondMarketingOffersService.fetchLocationPairs({
          destination: destinationLocationCode,
          originCountry: getCurrentCountry(this.languageService.langValue),
          lang: this.languageService.langValue,
        });
      })
    )
  );
}
